// extracted by mini-css-extract-plugin
export default {"listSection":"Sidebar_listSection__WmweH"};